import { range } from 'lodash';
import { AccountFormLoader, AccountWithdrawalLoader, MarketLoader, NotificationLoader, MarketSharesItemLoader, MarketWidgetLoader, BiggestGainsLoader, TableRowsLoader, LeaderboardsInfoLoader, OverviewMapLoader } from '@/components/content-loader';


const contentLoaderMixin = {
  components: {
    AccountFormLoader,
    AccountWithdrawalLoader,
    LeaderboardsInfoLoader,
    MarketLoader,
    MarketSharesItemLoader,
    MarketWidgetLoader,
    NotificationLoader,
    BiggestGainsLoader,
    TableRowsLoader,
    OverviewMapLoader,
  },
  data() {
    return {
      isComponentReady: false,
    };
  },
  methods: {
    loaderItems(number) {
      return range(0, number);
    },
  },
};


export default contentLoaderMixin;



// WEBPACK FOOTER //
// ./src/mixins/contentLoader.js